export default __webpack_public_path__ + "media/images/woman-with-pumpkin-1332b2e3766507529d66faf2b0a909a1.png";